import { EpiImage } from '@api/types';

export type ImageResizerParams = {
  width?: number;
  height?: number;
  format?: 'webp' | 'jpg' | 'png';
  quality?: number;
};

// TODO [kf] - revisit this logic
export const getEpiImageResizerUrl = (image: EpiImage, params?: ImageResizerParams): string => {
  if (typeof image === 'string') {
    return image.indexOf("?") > 0? image : getImageResizerUrl(image, params) || '';
  }
  const url = image?.url;
  const resizerRequestParams = new URLSearchParams(params as Record<string, string>);
  return `${url}?${resizerRequestParams.toString()}` || '';
};

export const getImageResizerUrl = (imageUrl: string, params?: ImageResizerParams): string => {
  if (!imageUrl) {
    return '';
  }
  const resizerRequestParams = new URLSearchParams(params as Record<string, string>);
  return `${imageUrl}?${resizerRequestParams.toString()}` || '';
};

export const isEpiImage = (image?: EpiImage) => {
  return image && typeof image === 'object' && image?.url;
};
